<style scoped>
    .vue-modal {
        display: block;
    }
</style>

<template>
    <div style="display:inline-block">
        <button
            class="btn btn-primary btn-sm"
            @click="openModal()"
        >
            <i v-if="!is_loading" class="fa fa-link" aria-hidden="true"></i>
            <span v-if="!is_loading" v-text="trans('main_button')"></span>
            <div class="la-ball-fall" v-else><div></div><div></div><div></div></div>
        </button>

        <div class="modal vue-modal" v-show="modal_is_opened">
            <div class="modal-dialog">
                <div class="modal-content">

                    <div class="modal-header">
                        <button type="button" class="close" @click="closeModal()" aria-label="Close">
                            <span aria-hidden="true">&times;</span></button>
                        <h4 class="modal-title" v-text="trans('title')"></h4>
                    </div>

                    <div class="modal-body" v-if="!is_processed && !is_loading">
                        <p class="lead text-mutted" v-text="trans('info')"></p>

                        <div v-for="item in selected_items" class="form-group">
                            <label>
                                <input type="radio" v-model="main_order_id" :value="item.id">
                                <span v-text="trans('order') + item.order_number"></span>
                            </label>
                        </div>
                    </div>

                    <div class="modal-body" v-if="is_loading" v-text="trans('loading')"></div>
                    <div class="modal-body" v-if="message" v-html="message"></div>

                    <div class="modal-footer" v-if="!is_processed">
                        <button type="button"
                                @click="sendOrders"
                                class="btn btn-success pull-right"
                                v-text="trans('apply_button')"
                        ></button>
                        <button type="button"
                                @click="closeModal()"
                                class="btn btn-danger pull-right"
                                v-text="trans('cancel_button', null)"
                        ></button>
                    </div>

                    <div class="modal-footer" v-else>
                        <button type="button" class="btn btn-success pull-right" @click="reload">Ок</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import * as Functions from '../Functions';

    export default {
        props: ['translations'],
        mounted: function() {
            Vue.http.headers.common['X-CSRF-TOKEN'] = document.querySelector('#token').getAttribute('content');
        },
        data: function () {
            return {
                message: null,
                is_loading: false,
                is_processed: false,
                modal_is_opened: false,

                main_order_id: null,
                selected_items: null,
            };
        },
        methods: {
            trans(name, path = 'orders_combiner') {
                return Functions.trans(this.translations, name, path);
            },
            openModal: function () {
                if (!this.selected_items || Object.keys(this.selected_items).length < 2) {
                    return this.orderNotFound();
                }

                this.modal_is_opened = true;
                this.main_order_id = this.selected_items[Object.keys(this.selected_items)[0]].id;
            },
            closeModal() {
                this.modal_is_opened = false;
            },
            orderNotFound: function () {
                alert(this.trans('error_min_quantity'));
            },
            sendOrders: function () {
                this.is_loading = true;

                this.$http.post('/shop/orders/combine', {
                    ids: Object.keys(this.selected_items),
                    main_order_id: this.main_order_id
                }).then((response) => {
                    this.is_loading = false;
                    this.is_processed = true;
                    this.message = response.data.message;
                }).catch((response) => {
                    alert(response.data.message);
                    this.reload();
                });
            },
            reload: function () {
                location.reload(true);
            }
        },
        created: function () {
            this.$root.$on('update:selected_items', (items) => {
                this.selected_items = items;
            });
        }
    }
</script>
